var _mask, _path, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_3004",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 19.097C18.6264 19.097 23.999 15.4933 23.999 11.048C23.999 6.60267 18.6264 2.99902 11.999 2.99902C5.37161 2.99902 -0.000976562 6.60267 -0.000976562 11.048C-0.000976562 14.2589 2.80197 17.0306 6.85616 18.3224V21.7799L11.5789 19.0921C11.7184 19.0954 11.8584 19.097 11.999 19.097Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85616 18.3224H8.35616V17.2261L7.31156 16.8932L6.85616 18.3224ZM6.85616 21.7799H5.35616V24.3595L7.5981 23.0836L6.85616 21.7799ZM11.5789 19.0921L11.6135 17.5925L11.1981 17.583L10.837 17.7885L11.5789 19.0921ZM22.499 11.048C22.499 12.6174 21.5509 14.2179 19.6487 15.4938C17.7562 16.7632 15.0561 17.597 11.999 17.597V20.597C15.5694 20.597 18.8693 19.629 21.3199 17.9852C23.7608 16.3479 25.499 13.924 25.499 11.048H22.499ZM11.999 4.49902C15.0561 4.49902 17.7562 5.33283 19.6487 6.60224C21.5509 7.87813 22.499 9.47863 22.499 11.048H25.499C25.499 8.17205 23.7608 5.74806 21.3199 4.11079C18.8693 2.46704 15.5694 1.49902 11.999 1.49902V4.49902ZM1.49902 11.048C1.49902 9.47863 2.44712 7.87813 4.34931 6.60224C6.24184 5.33283 8.942 4.49902 11.999 4.49902V1.49902C8.42863 1.49902 5.12879 2.46704 2.67817 4.11079C0.23722 5.74806 -1.50098 8.17205 -1.50098 11.048H1.49902ZM7.31156 16.8932C3.53345 15.6894 1.49902 13.304 1.49902 11.048H-1.50098C-1.50098 15.2137 2.07049 18.3718 6.40077 19.7516L7.31156 16.8932ZM5.35616 18.3224V21.7799H8.35616V18.3224H5.35616ZM7.5981 23.0836L12.3208 20.3958L10.837 17.7885L6.11423 20.4763L7.5981 23.0836ZM11.999 17.597C11.8699 17.597 11.7414 17.5955 11.6135 17.5925L11.5443 20.5917C11.6953 20.5952 11.8469 20.597 11.999 20.597V17.597Z",
    fill: "#122C44",
    mask: "url(#path-1-inside-1_1_3004)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.74902,
    y1: 10.6489,
    x2: 8.24902,
    y2: 10.6489,
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.749,
    y1: 10.6489,
    x2: 13.249,
    y2: 10.6489,
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.749,
    y1: 10.6489,
    x2: 18.249,
    y2: 10.6489,
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.94fd17194009daf88fd08cb026468242.svg";
export { ForwardRef as ReactComponent };